export default __webpack_public_path__ + "static/outlet_b.be18ca34475e1434a870d8c7248e2bcd.svg";